
const imageLoader = {
    methods: {
      loadImage(name) {
        return new URL(`../assets/${name}`, import.meta.url).href
      }
    }
  }
export default imageLoader;